define('maps/icons',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.placeUrl = exports.pin = void 0;
    var pinPath = "M 4.2016313,15.41833 C 2.488485,11.85599 1.1332538,8.67644 0.49495773,6.722 0.33428615,6.23003 0.13192533,5.45813 0.05968479,5.06166 -0.04250982,4.5008 -0.01494569,3.99705 0.15379287,3.34181 0.55709082,1.77572 1.8155259,0.52984 3.3918244,0.13606 3.8387464,0.02442 4.0366688,0 4.4947488,0 5.7060867,0 6.8134278,0.45804 7.6679598,1.31258 8.4787115,2.12333 8.9421662,3.18801 8.9851395,4.33849 9.0009685,4.76227 8.9351925,5.16693 8.7261159,5.93204 8.3296853,7.38277 7.4948234,9.51926 6.2145354,12.35942 5.5944278,13.73504 4.5244779,16 4.4947488,16 4.4873888,16 4.3554811,15.73825 4.2016313,15.41833 Z M 4.9977379,6.41142 C 5.7895883,6.21163 6.3646068,5.5572 6.4767384,4.72816 6.6104314,3.73971 5.9429423,2.77898 4.9561858,2.53959 4.7196834,2.48219 4.2698142,2.48219 4.0333118,2.53959 2.8865451,2.8178 2.2226367,4.02613 2.6063382,5.13672 2.8043091,5.70973 3.2991086,6.19654 3.8667845,6.37681 4.253917,6.49975 4.605055,6.5105 4.9977379,6.41141 Z";
    function pin(color) {
        return {
            path: pinPath,
            anchor: new google.maps.Point(4.5, 16),
            fillColor: color,
            fillOpacity: 1,
            strokeColor: "#111",
            strokeOpacity: 0.4
        };
    }
    exports.pin = pin;
    /**
     * Icon url for a place (dz, span, wingsuitable)
     */
    function placeUrl(place) {
        if (place.objectType === "B") {
            return "/assets/images/icons/kml/B-shadow.png";
        }
        else if (place.objectType === "A") {
            return "/assets/images/icons/kml/A-shadow.png";
        }
        else if (place.objectType === "S") {
            return "/assets/images/icons/kml/S-shadow.png";
        }
        else if (place.objectType === "E") {
            if (place.wingsuitable) {
                return "/assets/images/icons/kml/WS-shadow.png";
            }
            else {
                return "/assets/images/icons/kml/E-shadow.png";
            }
        }
        else if (place.objectType === "DZ") {
            return "/assets/images/icons/kml/DZ-shadow.png";
        }
        else if (place.objectType === "PG") {
            return "/assets/images/icons/kml/PG-shadow.png";
        }
        else if (place.objectType === "SIM") {
            return "/assets/images/icons/kml/WSS-shadow.png";
        }
        else if (place.objectType === "BDZ") {
            return "/assets/images/icons/kml/BDZ-shadow.png";
        }
        else if (place.objectType === "G") {
            return "/assets/images/icons/kml/G-shadow.png";
        }
        else {
            return "/assets/images/icons/kml/pin-shadow.png";
        }
    }
    exports.placeUrl = placeUrl;
});
//# sourceMappingURL=/assets/javascripts/maps/icons.js.map;
